import { useState, useEffect } from 'react';
import window from 'global/window';

/** MUI `breakpoints.up` returns `@media (…)` for styled-css; `matchMedia` needs the inner `(…)` only */
export function toMatchMediaQuery(breakpointUp) {
  return breakpointUp.replace(/^\s*@media\s+/i, '').trim();
}
var useMediaQuery = function useMediaQuery(query) {
  var _useState = useState(false),
    match = _useState[0],
    setMatch = _useState[1];
  var matchMediaType = typeof (window === null || window === void 0 ? void 0 : window.matchMedia);
  useEffect(function () {
    if (matchMediaType !== 'function') {
      return undefined;
    }
    var matchObject = window.matchMedia(query);
    var updateMatch = function updateMatch() {
      return setMatch(matchObject.matches);
    };
    updateMatch();
    if (matchObject.addEventListener) {
      matchObject.addEventListener('change', updateMatch);
      return function () {
        matchObject.removeEventListener('change', updateMatch);
      };
    }
    matchObject.addListener(updateMatch);
    return function () {
      matchObject.removeListener(updateMatch);
    };
  }, [query, matchMediaType]);
  return match;
};
export default useMediaQuery;